'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { createContext, useContext } from 'react';
import { useMediaQuery } from '@s7/hooks';

var ERROR_MESSAGE = "Попытка получить доступ к MediaQueryContext вне контекста";
var createMediaQueryContext = function() {
    var MediaQueryProvider = function MediaQueryProvider(props) {
        var children = props.children, query = props.query, options = props.options;
        var value = useMediaQuery(query, options);
        return /*#__PURE__*/ jsx(MediaQueryContext.Provider, {
            value: value,
            children: children
        });
    };
    var MediaQueryContext = /*#__PURE__*/ createContext([]);
    var useSafeContext = function() {
        var context = useContext(MediaQueryContext);
        if (context === null) {
            throw new Error(ERROR_MESSAGE);
        }
        return context;
    };
    return [
        MediaQueryProvider,
        useSafeContext
    ];
};

export { ERROR_MESSAGE, createMediaQueryContext };
